export default "__VITE_ASSET__a9rAxlmt__"